import {Routes} from '@angular/router';

export const goodsDetailPropertyManagementRoutes: Routes = [
      {
        path: 'goodsDetailPropertyManagement',
        loadComponent: () => import('./goods-detail-property-management.component').then(m => m.GoodsDetailPropertyManagementComponent),
        data: { title: '详情页参数' },
      },
];
